import { Box, Button, Typography } from "@mui/material";
import { useGetShipstationQuotes } from "@queries/useGetShipStationQuotes";

export default function GetShipstationQuotesButton() {
  const { data, error, isLoading, isSuccess, isError, refetch } = useGetShipstationQuotes({
    toCountry: "US",
    toPostalCode: "80206",
    toState: "CO",
    toCity: "Denver",
    weight: {
      units: "lb",
      value: 5,
    },
    email: "test@example.com",
    firstName: "John",
    lastName: "Doe",
    products: [{ sku: "ACC069", quantity: 1 }],
  });

  const handleClick = () => {
    refetch();
  };

  return (
    <Box sx={{ p: "24px" }}>
      <Button onClick={handleClick} variant="contained">
        {isLoading ? "Getting..." : "Get ShipStation Quotes"}
      </Button>

      {isSuccess && (
        <Typography sx={{ mt: "16px", color: "green" }}>
          ✅ Success! data: {JSON.stringify(data)}
        </Typography>
      )}

      {isError && (
        <Typography sx={{ mt: "16px", color: "red" }}>
          ❌ Error: {(error as Error).message}
        </Typography>
      )}
    </Box>
  );
}
